import { render, staticRenderFns } from "./DocumentViewerShell.vue?vue&type=template&id=7d3710dd&scoped=true"
import script from "./DocumentViewerShell.vue?vue&type=script&lang=js"
export * from "./DocumentViewerShell.vue?vue&type=script&lang=js"
import style0 from "./DocumentViewerShell.vue?vue&type=style&index=0&id=7d3710dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3710dd",
  null
  
)

export default component.exports